import { lazy, Suspense } from "react";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEOHead from "@/components/common/SEOHead";
import HeroSection from "@/components/sections/HeroSection";

// Below-the-fold — code-split to shrink the initial JS payload
const TrustedTechnologies = lazy(() => import("@/components/sections/TrustedTechnologies"));
const NewsSection = lazy(() => import("@/components/sections/NewsSection"));
const AboutSection = lazy(() => import("@/components/sections/AboutSection"));
const ServicesSection = lazy(() => import("@/components/sections/ServicesSection"));
const TrainingSection = lazy(() => import("@/components/sections/TrainingSection"));
const TestimonialsSection = lazy(() => import("@/components/sections/TestimonialsSection"));
const PartnersSection = lazy(() => import("@/components/sections/PartnersSection"));
const CTASection = lazy(() => import("@/components/sections/CTASection"));

// Reserve vertical space so lazy sections don't cause layout shift while loading
const SectionFallback = () => <div className="min-h-[400px]" aria-hidden="true" />;

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="SYNRA — AI & Automation Platform Morocco"
        description="Morocco's leading AI & Automation platform. Youth AI training, business automation with n8n, and a partner program for agencies."
        path="/"
        keywords="AI Morocco, automation, n8n, intelligence artificielle Maroc, الذكاء الاصطناعي"
      />
      <Header />
      <main>
        <HeroSection />
        <Suspense fallback={<SectionFallback />}>
          <TrustedTechnologies />
          <NewsSection />
          <AboutSection />
          <ServicesSection />
          <TrainingSection />
          <TestimonialsSection />
          <PartnersSection />
          <CTASection />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
